import {
	createBrandThemeDefinition,
	createThemePreset,
	createThemeTokens,
	extendThemeTokens,
} from '../../../app/config/theme/helpers'

const defaultLight = createThemeTokens({
	background: 'oklch(0.9900 0 0)',
	foreground: 'oklch(0 0 0)',
	card: 'oklch(1 0 0)',
	'card-foreground': 'oklch(0 0 0)',
	popover: 'oklch(0.9900 0 0)',
	'popover-foreground': 'oklch(0 0 0)',
	primary: 'oklch(0 0 0)',
	'primary-foreground': 'oklch(0.9618 0.0263 91.05)',
	secondary: 'oklch(0.9650 0 0)',
	'secondary-foreground': 'oklch(0 0 0)',
	muted: 'oklch(0.9650 0 0)',
	'muted-foreground': 'oklch(0.4400 0 0)',
	accent: 'oklch(0.9400 0 0)',
	'accent-foreground': 'oklch(0 0 0)',
	destructive: 'oklch(0.6300 0.1900 23.0300)',
	'destructive-foreground': 'oklch(1 0 0)',
	border: 'oklch(0.9200 0 0)',
	input: 'oklch(0.6200 0 0)',
	ring: 'oklch(0 0 0)',
	'chart-1': 'oklch(0.2500 0 0)',
	'chart-2': 'oklch(0.4500 0 0)',
	'chart-3': 'oklch(0.6500 0 0)',
	'chart-4': 'oklch(0.8500 0 0)',
	'chart-5': 'oklch(0.6506 0.1172 91.06)',
	sidebar: 'oklch(0.9900 0 0)',
	'sidebar-foreground': 'oklch(0 0 0)',
	'sidebar-primary': 'oklch(0 0 0)',
	'sidebar-primary-foreground': 'oklch(1 0 0)',
	'sidebar-accent': 'oklch(0.9650 0 0)',
	'sidebar-accent-foreground': 'oklch(0 0 0)',
	'sidebar-border': 'oklch(0.9200 0 0)',
	'sidebar-ring': 'oklch(0 0 0)',
	'font-sans': "'Geist Variable', system-ui, sans-serif",
	'font-serif': "'Newsreader Variable', Georgia, serif",
	'font-mono': "'Geist Mono Variable', ui-monospace, monospace",
	radius: '0.375rem',
	'shadow-x': '0px',
	'shadow-y': '1px',
	'shadow-blur': '2px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.18',
	'shadow-color': 'hsl(0 0% 0%)',
	'shadow-2xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
	'shadow-xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
	'shadow-sm':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
	shadow:
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
	'shadow-md':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 2px 4px -1px hsl(0 0% 0% / 0.18)',
	'shadow-lg':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 4px 6px -1px hsl(0 0% 0% / 0.18)',
	'shadow-xl':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 8px 10px -1px hsl(0 0% 0% / 0.18)',
	'shadow-2xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.45)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--foreground)',
	'study-progress-completed': 'var(--foreground)',
	'study-progress-deadline': 'oklch(0.56 0 0)',
	surface: 'var(--card)',
	'surface-elevated': 'oklch(0.98 0 0)',
	media: 'oklch(0.16 0 0)',
	overlay: '0 0% 0% / 0.65',
	'status-success-surface': 'oklch(0.97 0.04 145)',
	'status-success-text': 'oklch(0.42 0.12 145)',
	'status-success-border': 'oklch(0.82 0.05 145)',
	'status-warning-surface': 'oklch(0.97 0.05 85)',
	'status-warning-text': 'oklch(0.48 0.1 85)',
	'status-warning-border': 'oklch(0.84 0.06 85)',
	'status-danger-surface': 'oklch(0.97 0.05 25)',
	'status-danger-text': 'oklch(0.45 0.14 25)',
	'status-danger-border': 'oklch(0.83 0.06 25)',
	'status-info-surface': 'oklch(0.97 0.03 250)',
	'status-info-text': 'oklch(0.45 0.1 250)',
	'status-info-border': 'oklch(0.83 0.04 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.15 0 0)',
	'carousel-slide-0-foreground': 'oklch(1 0 0)',
	'carousel-slide-1': 'oklch(0.25 0.04 91)',
	'carousel-slide-1-foreground': 'oklch(0.96 0.02 91)',
	'carousel-slide-2': 'oklch(0.20 0 0)',
	'carousel-slide-2-foreground': 'oklch(1 0 0)',
	'carousel-slide-3': 'oklch(0.30 0.06 91)',
	'carousel-slide-3-foreground': 'oklch(0.96 0.02 91)',
	'carousel-slide-4': 'oklch(0.12 0 0)',
	'carousel-slide-4-foreground': 'oklch(1 0 0)',
	'reading-foreground': 'oklch(0.2200 0 0)',
	'border-strong': 'oklch(0.6200 0 0)',
	gold: 'oklch(0.6506 0.1172 91.06)',
	'gold-text': 'oklch(0.5000 0.0950 91)',
	'gold-wash': 'oklch(0.9650 0.0250 91)',
})

const defaultDark = createThemeTokens({
	background: 'oklch(0.21 0 0)',
	foreground: 'oklch(0.97 0 0)',
	card: 'oklch(0.245 0 0)',
	'card-foreground': 'oklch(0.97 0 0)',
	popover: 'oklch(0.27 0 0)',
	'popover-foreground': 'oklch(0.97 0 0)',
	primary: 'oklch(0.97 0 0)',
	'primary-foreground': 'oklch(0.21 0 0)',
	secondary: 'oklch(0.27 0 0)',
	'secondary-foreground': 'oklch(0.97 0 0)',
	muted: 'oklch(0.27 0 0)',
	'muted-foreground': 'oklch(0.7200 0 0)',
	accent: 'oklch(0.30 0 0)',
	'accent-foreground': 'oklch(0.97 0 0)',
	destructive: 'oklch(0.6900 0.2000 23.9100)',
	'destructive-foreground': 'oklch(0 0 0)',
	border: 'oklch(0.33 0 0)',
	input: 'oklch(0.56 0 0)',
	ring: 'oklch(0.97 0 0)',
	'chart-1': 'oklch(0.95 0 0)',
	'chart-2': 'oklch(0.75 0 0)',
	'chart-3': 'oklch(0.55 0 0)',
	'chart-4': 'oklch(0.40 0 0)',
	'chart-5': 'oklch(0.78 0.11 91)',
	sidebar: 'oklch(0.18 0 0)',
	'sidebar-foreground': 'oklch(0.97 0 0)',
	'sidebar-primary': 'oklch(0.97 0 0)',
	'sidebar-primary-foreground': 'oklch(0.21 0 0)',
	'sidebar-accent': 'oklch(0.27 0 0)',
	'sidebar-accent-foreground': 'oklch(0.97 0 0)',
	'sidebar-border': 'oklch(0.33 0 0)',
	'sidebar-ring': 'oklch(0.97 0 0)',
	'font-sans': "'Geist Variable', system-ui, sans-serif",
	'font-serif': "'Newsreader Variable', Georgia, serif",
	'font-mono': "'Geist Mono Variable', ui-monospace, monospace",
	radius: '0.375rem',
	'shadow-x': '0px',
	'shadow-y': '1px',
	'shadow-blur': '2px',
	'shadow-spread': '0px',
	'shadow-opacity': '0.18',
	'shadow-color': 'hsl(0 0% 0%)',
	'shadow-2xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
	'shadow-xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
	'shadow-sm':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
	shadow:
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
	'shadow-md':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 2px 4px -1px hsl(0 0% 0% / 0.18)',
	'shadow-lg':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 4px 6px -1px hsl(0 0% 0% / 0.18)',
	'shadow-xl':
		'0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 8px 10px -1px hsl(0 0% 0% / 0.18)',
	'shadow-2xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.45)',
	'tracking-normal': '0em',
	spacing: '0.25rem',
	'study-progress-not-started': 'var(--muted-foreground)',
	'study-progress-in-progress': 'var(--foreground)',
	'study-progress-completed': 'var(--foreground)',
	'study-progress-deadline': 'oklch(0.92 0 0)',
	surface: 'oklch(0.245 0 0)',
	'surface-elevated': 'oklch(0.30 0 0)',
	media: 'oklch(0.12 0 0)',
	overlay: '0 0% 0% / 0.75',
	'status-success-surface': 'oklch(0.26 0.06 145)',
	'status-success-text': 'oklch(0.88 0.06 145)',
	'status-success-border': 'oklch(0.4 0.07 145)',
	'status-warning-surface': 'oklch(0.26 0.05 85)',
	'status-warning-text': 'oklch(0.9 0.07 85)',
	'status-warning-border': 'oklch(0.4 0.06 85)',
	'status-danger-surface': 'oklch(0.26 0.06 25)',
	'status-danger-text': 'oklch(0.9 0.08 25)',
	'status-danger-border': 'oklch(0.4 0.07 25)',
	'status-info-surface': 'oklch(0.26 0.04 250)',
	'status-info-text': 'oklch(0.88 0.06 250)',
	'status-info-border': 'oklch(0.4 0.05 250)',
	success: 'var(--status-success-text)',
	warning: 'var(--status-warning-text)',
	info: 'var(--status-info-text)',
	danger: 'var(--status-danger-text)',
	'carousel-slide-0': 'oklch(0.12 0 0)',
	'carousel-slide-0-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-1': 'oklch(0.20 0.04 91)',
	'carousel-slide-1-foreground': 'oklch(0.96 0.02 91)',
	'carousel-slide-2': 'oklch(0.16 0 0)',
	'carousel-slide-2-foreground': 'oklch(0.95 0 0)',
	'carousel-slide-3': 'oklch(0.24 0.06 91)',
	'carousel-slide-3-foreground': 'oklch(0.96 0.02 91)',
	'carousel-slide-4': 'oklch(0.10 0 0)',
	'carousel-slide-4-foreground': 'oklch(0.95 0 0)',
	'reading-foreground': 'oklch(0.88 0 0)',
	'border-strong': 'oklch(0.56 0 0)',
	gold: 'oklch(0.78 0.11 91)',
	'gold-text': 'oklch(0.80 0.10 91)',
	'gold-wash': 'oklch(0.29 0.03 91)',
})

const noirLight = extendThemeTokens(defaultLight, {
	background: 'oklch(0.964 0 0)',
	card: 'oklch(0.986 0 0)',
	primary: 'oklch(0.14 0 0)',
	gold: 'oklch(0.74 0.1 83)',
	accent: 'oklch(0.91 0.01 85)',
	ring: 'oklch(0.74 0.1 83)',
	sidebar: 'oklch(0.965 0.004 85)',
	'sidebar-primary': 'oklch(0.12 0 0)',
	'sidebar-accent': 'oklch(0.89 0.015 84)',
	'surface-elevated': 'oklch(0.995 0 0)',
	'carousel-slide-1': 'oklch(0.36 0.06 83)',
	'carousel-slide-3': 'oklch(0.38 0.07 86)',
})

const noirDark = extendThemeTokens(defaultDark, {
	background: 'oklch(0.11 0 0)',
	card: 'oklch(0.17 0 0)',
	popover: 'oklch(0.2 0 0)',
	primary: 'oklch(0.96 0.01 85)',
	'primary-foreground': 'oklch(0.08 0 0)',
	secondary: 'oklch(0.22 0.015 84)',
	'secondary-foreground': 'oklch(0.95 0.01 84)',
	accent: 'oklch(0.25 0.02 84)',
	ring: 'oklch(0.79 0.08 83)',
	sidebar: 'oklch(0.08 0 0)',
	'sidebar-primary': 'oklch(0.92 0.01 85)',
	'sidebar-primary-foreground': 'oklch(0.08 0 0)',
	'sidebar-accent': 'oklch(0.15 0.01 84)',
	'sidebar-border': 'oklch(0.18 0.004 84)',
	'surface-elevated': 'oklch(0.24 0 0)',
	'carousel-slide-1': 'oklch(0.26 0.03 84)',
	'carousel-slide-3': 'oklch(0.3 0.04 84)',
})

const arkeiasTheme = createBrandThemeDefinition({
	brandKey: 'arkeias',
	defaultPreset: 'default',
	presets: {
		default: createThemePreset({
			key: 'default',
			label: 'Brand default',
			description:
				'High-contrast monochrome studio with warm architectural accents.',
			tokens: {
				light: defaultLight,
				dark: defaultDark,
			},
		}),
		noir: createThemePreset({
			key: 'noir',
			label: 'Noir studio',
			description:
				'Darker editorial surfaces with warmer gold accents for a more dramatic workspace.',
			tokens: {
				light: noirLight,
				dark: noirDark,
			},
		}),
	},
})

export default arkeiasTheme
